import React from 'react';

export default function RefundPolicy() {
  const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    color: '#333',
    padding: '20px 40px',
    maxWidth: '800px',
    margin: '0 auto',
  };

  const headingStyle = {
    color: '#0056b3',
    borderBottom: '2px solid #0056b3',
    paddingBottom: '10px',
  };

  const sectionStyle = {
    marginBottom: '20px',
    padding: '15px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9',
  };
  
  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Refund Policy</h1>
      <p>Please review our refund policy options below. The applicable policy is determined by the nature of the service or product you have purchased.</p>

      <div style={sectionStyle}>
        <h3>Option 1: For Approved Refunds</h3>
        <p>Once the refund is approved, it will take <strong>7 business days</strong> to credit to your bank account.</p>
      </div>

      <div style={sectionStyle}>
        <h3>Option 2: For Services with No Refund</h3>
        <p>For our services, we don't entertain refunds.</p>
      </div>
    </div>
  );
}